const priceFormat = (price: number | null | undefined): string => {
  if (price || price === 0) {
    return "$".concat(price.toLocaleString("de-DE"));
  }
  return "";
};
export default priceFormat;
